import { useSearchParams } from 'react-router-dom';
import { BiCheckCircle, BiXCircle, BiTime, BiError, BiInfoCircle } from 'react-icons/bi';
import logo from '../assets/marginpal_logo.svg';

const statusConfig = {
    accepted: {
        icon: <BiCheckCircle size={48} color="#16a34a" />,
        title: 'Quote Accepted!',
        message: 'Thank you for accepting this quote. The business has been notified.',
        bg: '#f0fdf4',
        border: '#bbf7d0',
    },
    rejected: {
        icon: <BiXCircle size={48} color="#dc2626" />,
        title: 'Quote Declined',
        message: 'This quote has been declined. The business has been notified.',
        bg: '#fef2f2',
        border: '#fecaca',
    },
    expired: {
        icon: <BiTime size={48} color="#ea580c" />,
        title: 'Link Expired',
        message: 'This link has expired. Please contact the business directly.',
        bg: '#fff7ed',
        border: '#fed7aa',
    },
    invalid: {
        icon: <BiError size={48} color="#dc2626" />,
        title: 'Invalid Link',
        message: 'This link is not valid.',
        bg: '#fef2f2',
        border: '#fecaca',
    },
    'already-responded': {
        icon: <BiInfoCircle size={48} color="#2563eb" />,
        title: 'Already Responded',
        message: "You've already responded to this quote.",
        bg: '#eff6ff',
        border: '#bfdbfe',
    },
};

export default function QuoteResponsePage() {
    const [searchParams] = useSearchParams();
    const status = searchParams.get('status');
    const config = statusConfig[status] ?? statusConfig.invalid;

    return (
        <div
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: '100vh', background: '#f8f9fa' }}
        >
            <div
                style={{
                    background: '#fff',
                    borderRadius: '12px',
                    border: `1px solid ${config.border}`,
                    maxWidth: 460,
                    width: '100%',
                    padding: '2.5rem 2rem',
                    textAlign: 'center',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                }}
            >
                <img
                    src={logo}
                    alt="MarginPal"
                    style={{ height: 36, marginBottom: '2rem' }}
                />
                <div
                    style={{
                        background: config.bg,
                        borderRadius: '50%',
                        width: 80,
                        height: 80,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 1.25rem',
                    }}
                >
                    {config.icon}
                </div>
                <h2 className="fw-bold mb-2" style={{ fontSize: '1.5rem' }}>
                    {config.title}
                </h2>
                <p className="text-muted mb-0">{config.message}</p>
            </div>
        </div>
    );
}
